import SpaceDetailsCard from './components/SpaceDetailsCard/SpaceDetailsCard';
import SpaceDetails from './SpaceDetails';

export { SpaceDetails, SpaceDetailsCard };
